import { Card } from "@/components/ui/card";
import { UserRound, CreditCard, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const steps = [
  {
    icon: UserRound,
    title: "Enter your details",
    desc: "Share your full name and 10-digit mobile number. That’s all we need to create your card.",
    accent: "01",
  },
  {
    icon: CreditCard,
    title: "Pay ₹100 securely",
    desc: "Complete the one-time payment through Razorpay using UPI, card, wallet or net-banking.",
    accent: "02",
  },
  {
    icon: MessageCircle,
    title: "Get card on WhatsApp",
    desc: "Your card and SMS receipt arrive in seconds with a unique membership number ready to use.",
    accent: "03",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="relative py-20 sm:py-28 bg-gradient-soft">
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
              How it works
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
              Three taps to your <span className="text-gradient-aqua">digital health card.</span>
            </h2>
          </div>
          <Link to="/generate">
            <Button size="lg" className="bg-gradient-primary text-primary-foreground shadow-elegant rounded-xl">
              Start now – ₹100
            </Button>
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-5 relative">
          {/* Connector line */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-primary/35 to-transparent" />

          {steps.map(({ icon: Icon, title, desc, accent }) => (
            <Card
              key={accent}
              className="relative p-6 sm:p-7 border-border/60 bg-background hover:shadow-elegant transition-shadow duration-300 flex flex-col"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-primary text-primary-foreground shadow-elegant">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="font-mono text-xs text-muted-foreground tracking-widest">
                  STEP {accent}
                </span>
              </div>
              <h3 className="font-display font-semibold text-xl text-foreground">
                {title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {desc}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
